export enum Mode {
  FullWave = "Full-wave",
  HalfWave = "Half-wave",
}
